var render = function render(_c,_vm){return _c('div',{class:[
    _vm.$style.badge,
    _vm.props.disabled && _vm.$style.disabled
  ]},[_vm._v(" "+_vm._s(_vm.props.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }